import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Cloudinfranum() {
  return (
    <section className="cloud_infra_num generative_ai_future p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why is Generative <span>AI the Future?</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-md-5 mt-sm-0">
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2 style={{ color: "#314252" }}>$4.4 trillion</h2>
              <p>
                annual boost to the global economy is anticipated with
                generative AI, matching the GDP of 6 out of the G8 countries.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2 style={{ color: "#314252" }}>15%</h2>
              <p>
                of new applications might be built by AI from scratch with no
                human intervention by 2027, revolutionising software
                development.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2 style={{ color: "#314252" }}>54%</h2>
              <p>
                of companies have implemented GenAI in some areas of their
                operations within a year of ChatGPT's release
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2 style={{ color: "#314252" }}>28%</h2>
              <p>
                of companies with AI adoption report that generative AI is
                already on their board's agenda.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudinfranum;
